import { Header } from './Header';
import { Item } from './Item';
import { Root } from './Root';

export const QuotationList = {
  Header,
  Item,
  Root,
};
